import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import Admonition from "../../components/Admonitions/Admonition"
import {approveCheckDeposit} from "../../resources/checkDeposits"

interface ApproveCheckModalProps {
	id: string
	closeModal: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ApproveCheckModal({id, closeModal, onSuccess}: ApproveCheckModalProps) {
	const accessToken = useAccessToken()
	const [approveState, setApprovedState] = useAsyncResultIdle(approveCheckDeposit)

	return (
		<AsyncResultModal
			title={`You Are About To Approve Check ID #${id}`}
			close={refreshAndClose(onSuccess, closeModal)}
			buttonClassname="is-success"
			state={approveState}
			buttonText="Approve"
			successText="Check is approved"
			onSubmit={() => {
				setApprovedState({id, accessToken})
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<Admonition
				type={"is-warning"}
				message={
					<p>
						{
							"Approving a check is a final action and cannot be undone. Checks may still be rejected later on in the check deposit process."
						}
					</p>
				}
				title={"Note"}
			/>
		</AsyncResultModal>
	)
}
